window.initContactSection ?? (() => {
    window.initContactSection = (section_id) => {

    const replaceTitleTMs = () => {
        document.querySelectorAll(`section#shopify-section-${section_id} .careline-20-text-cta .careline-20-title`).forEach((title) => {
            title.innerHTML = title.innerHTML.replace(
                /™/g,
                '<span class="tm">™</span>'
                );
        });
    }

    replaceTitleTMs();

    document.addEventListener('shopify:section:load', function () {
      replaceTitleTMs();
    });
}
  
})();
